import LeadsInfo from '@/components/LeadsInfo/LeadsInfo';
export default LeadsInfo;
